// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.foto-crop-content {
  --background: #ffffff;
}

.crop-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 16px 24px 8px;
  position: relative;
}
.crop-header .close-btn {
  position: absolute;
  top: 12px;
  right: 16px;
  background: transparent;
  border: none;
  cursor: pointer;
  font-size: 22px;
  line-height: 1;
  color: #333;
}
.crop-header .crop-title {
  margin: 0;
  font-weight: 700;
  font-size: 18px;
  color: #1a1a1a;
}
.crop-header .crop-subtitle {
  margin-top: 4px;
  font-size: 13px;
  color: #6b6b6b;
}

.crop-stage {
  display: flex;
  justify-content: center;
  align-items: center;
  background: var(--ion-color-primary, #c5132c);
  padding: 20px;
  margin: 8px 16px 0;
  border-radius: 4px;
  min-height: 280px;
}
.crop-stage .crop-canvas {
  cursor: grab;
  touch-action: none;
  border-radius: 2px;
  background: transparent;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.08);
}
.crop-stage .crop-canvas:active {
  cursor: grabbing;
}

.crop-zoom-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 32px 0;
}
.crop-zoom-row .zoom-range {
  flex: 1;
  --bar-background-active: var(--ion-color-primary, #c5132c);
  --knob-background: var(--ion-color-primary, #c5132c);
}
.crop-zoom-row .zoom-icon-sm {
  font-size: 16px;
  color: #6b6b6b;
}
.crop-zoom-row .zoom-icon-lg {
  font-size: 24px;
  color: #6b6b6b;
}

.crop-buttons {
  display: flex;
  justify-content: center;
  gap: 16px;
  padding: 8px 24px 24px;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/shared/components/modals/foto-crop-modal/foto-crop-modal.component.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;AACF;AACE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,WAAA;AACJ;AAEE;EACE,SAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAAJ;AAGE;EACE,eAAA;EACA,eAAA;EACA,cAAA;AADJ;;AAKA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,6CAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AAFF;AAIE;EACE,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,uBAAA;EACA,yCAAA;AAFJ;AAII;EACE,gBAAA;AAFN;;AAOA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,oBAAA;AAJF;AAME;EACE,OAAA;EACA,0DAAA;EACA,oDAAA;AAJJ;AAOE;EACE,eAAA;EACA,cAAA;AALJ;AAQE;EACE,eAAA;EACA,cAAA;AANJ;;AAUA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,sBAAA;AAPF","sourcesContent":[".foto-crop-content {\n  --background: #ffffff;\n}\n\n.crop-header {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  padding: 16px 24px 8px;\n  position: relative;\n\n  .close-btn {\n    position: absolute;\n    top: 12px;\n    right: 16px;\n    background: transparent;\n    border: none;\n    cursor: pointer;\n    font-size: 22px;\n    line-height: 1;\n    color: #333;\n  }\n\n  .crop-title {\n    margin: 0;\n    font-weight: 700;\n    font-size: 18px;\n    color: #1a1a1a;\n  }\n\n  .crop-subtitle {\n    margin-top: 4px;\n    font-size: 13px;\n    color: #6b6b6b;\n  }\n}\n\n.crop-stage {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: var(--ion-color-primary, #c5132c);\n  padding: 20px;\n  margin: 8px 16px 0;\n  border-radius: 4px;\n  min-height: 280px;\n\n  .crop-canvas {\n    cursor: grab;\n    touch-action: none;\n    border-radius: 2px;\n    background: transparent;\n    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.08);\n\n    &:active {\n      cursor: grabbing;\n    }\n  }\n}\n\n.crop-zoom-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 16px 32px 0;\n\n  .zoom-range {\n    flex: 1;\n    --bar-background-active: var(--ion-color-primary, #c5132c);\n    --knob-background: var(--ion-color-primary, #c5132c);\n  }\n\n  .zoom-icon-sm {\n    font-size: 16px;\n    color: #6b6b6b;\n  }\n\n  .zoom-icon-lg {\n    font-size: 24px;\n    color: #6b6b6b;\n  }\n}\n\n.crop-buttons {\n  display: flex;\n  justify-content: center;\n  gap: 16px;\n  padding: 8px 24px 24px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
